/** 按 Intl 的三字母币种格式校验，不推断缺失币种。 */
const normalizeCurrency = (currency: string | null | undefined): string | null => {
  const value = currency?.trim().toUpperCase()
  return value && /^[A-Z]{3}$/.test(value) ? value : null
}

export const formatContractCurrency = (currency: string | null | undefined): string => normalizeCurrency(currency) || '-'

export const formatContractAmount = (amount: number | null | undefined, currency: string | null | undefined): string => {
  if (amount === null || amount === undefined) return '—'
  const code = normalizeCurrency(currency)
  return new Intl.NumberFormat('zh-CN', code ? {
    style: 'currency', currency: code, minimumFractionDigits: 2
  } : {
    minimumFractionDigits: 2, maximumFractionDigits: 20
  }).format(amount)
}
